// extracted by mini-css-extract-plugin
export default {"modal":"LogoutPopup_modal__o204m","modal_overlay":"LogoutPopup_modal_overlay__8DVYJ"};